import { render, staticRenderFns } from "./ResellerCart.vue?vue&type=template&id=654a6358&scoped=true"
import script from "./ResellerCart.vue?vue&type=script&lang=js"
export * from "./ResellerCart.vue?vue&type=script&lang=js"
import style0 from "./ResellerCart.vue?vue&type=style&index=0&id=654a6358&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654a6358",
  null
  
)

export default component.exports